import { BaseCommand } from './BaseCommand';
import { MapCommandType } from '../types';
import { IPolygonConfig } from '../../types';
import { PolygonManager } from '../../managers/PolygonManager';

export class AddPolygonCommand extends BaseCommand {
  private polygonManager: PolygonManager;
  private polygon: IPolygonConfig;

  constructor(polygonManager: PolygonManager, polygon: IPolygonConfig) {
    super(MapCommandType.ADD_POLYGON, `Add polygon with ${polygon.coordinates.length} points`);
    this.polygonManager = polygonManager;
    this.polygon = polygon;
  }

  execute(): void {
    this.polygonManager.addPolygon(this.polygon);
  }

  undo(): void {
    this.polygonManager.removePolygon(this.polygon.id);
  }

  canExecute(): boolean {
    return !this.polygonManager.hasPolygon(this.polygon.id);
  }

  canUndo(): boolean {
    return this.polygonManager.hasPolygon(this.polygon.id);
  }
}

export class RemovePolygonCommand extends BaseCommand {
  private polygonManager: PolygonManager;
  private polygon: IPolygonConfig;

  constructor(polygonManager: PolygonManager, polygon: IPolygonConfig) {
    super(MapCommandType.REMOVE_POLYGON, `Remove polygon ${polygon.id}`);
    this.polygonManager = polygonManager;
    this.polygon = polygon;
  }

  execute(): void {
    this.polygonManager.removePolygon(this.polygon.id);
  }

  undo(): void {
    this.polygonManager.addPolygon(this.polygon);
  }

  canExecute(): boolean {
    return this.polygonManager.hasPolygon(this.polygon.id);
  }

  canUndo(): boolean {
    return !this.polygonManager.hasPolygon(this.polygon.id);
  }
}

export class UpdatePolygonCommand extends BaseCommand {
  private polygonManager: PolygonManager;
  private newPolygon: IPolygonConfig;
  private previousPolygon: IPolygonConfig;

  constructor(
    polygonManager: PolygonManager,
    newPolygon: IPolygonConfig,
    previousPolygon: IPolygonConfig
  ) {
    super(MapCommandType.UPDATE_POLYGON, `Update polygon ${newPolygon.id}`);
    this.polygonManager = polygonManager;
    this.newPolygon = newPolygon;
    this.previousPolygon = previousPolygon;
  }

  execute(): void {
    this.polygonManager.updatePolygon(this.newPolygon);
  }

  undo(): void {
    this.polygonManager.updatePolygon(this.previousPolygon);
  }

  canExecute(): boolean {
    return this.polygonManager.hasPolygon(this.newPolygon.id);
  }

  canUndo(): boolean {
    return this.polygonManager.hasPolygon(this.previousPolygon.id);
  }
}
